var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.702 20.8q-3.334 0-5.678-2.363t-2.343-5.709q0-1.303.4-2.503.402-1.2 1.204-2.3L2.775 4.35a.98.98 0 0 1-.275-.715q0-.435.276-.715a.94.94 0 0 1 .702-.281q.426 0 .701.28l17.045 17.37a.98.98 0 0 1 .276.715q0 .435-.276.715a.94.94 0 0 1-.702.281.94.94 0 0 1-.701-.281l-2.407-2.452a8.3 8.3 0 0 1-2.206 1.137 7.8 7.8 0 0 1-2.506.395m0-2.044q.902 0 1.717-.255a6.5 6.5 0 0 0 1.541-.716L7.69 9.407a6.3 6.3 0 0 0-.765 1.635 6 6 0 0 0-.238 1.686q0 2.503 1.755 4.266t4.26 1.762m5.665-11.699q1.503 1.533 2.043 3.487a8 8 0 0 1 .087 3.946.9.9 0 0 1-.35.562 1.03 1.03 0 0 1-.627.205q-.552 0-.79-.46a1.35 1.35 0 0 1-.113-.97 4.67 4.67 0 0 0-.125-2.823 6.6 6.6 0 0 0-1.529-2.465l-4.261-4.291-1.504 1.507a.9.9 0 0 1-.702.268.99.99 0 0 1-.702-.294q-.3-.306-.3-.728 0-.42.3-.702l1.855-1.865q.226-.23.501-.332.276-.102.552-.102.275 0 .551.115t.502.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWater);
export default __webpack_public_path__ + "static/media/no_water.28a5bc16193ae60eac2f774e04d6b98c.svg";
export { ForwardRef as ReactComponent };